/**
 * Bật log debug sidebar / API menu:
 *   localStorage.setItem('DEBUG_SIDEBAR', '1')
 * Tắt:
 *   localStorage.removeItem('DEBUG_SIDEBAR')
 * Sau đó F5, mở DevTools → Console, copy toàn bộ dòng [SidebarDebug] gửi lại.
 */

const FLAG = 'DEBUG_SIDEBAR';

export function sidebarDebugEnabled(): boolean {
  try {
    return (
      typeof localStorage !== 'undefined' &&
      localStorage.getItem(FLAG) === '1'
    );
  } catch {
    return false;
  }
}

export function sidebarDebug(tag: string, payload?: unknown): void {
  if (!sidebarDebugEnabled()) {
    return;
  }
  const ts = new Date().toISOString();
  if (payload !== undefined) {
    console.info(`[SidebarDebug ${ts}] ${tag}`, payload);
  } else {
    console.info(`[SidebarDebug ${ts}] ${tag}`);
  }
}

/** Rút gọn 1 node menu để log (tránh vòng lặp / quá dài) */
export function summarizeMenuNode(n: unknown, depth = 0): Record<string, unknown> | string {
  if (n == null || typeof n !== 'object') {
    return String(n);
  }
  if (depth > 3) {
    return '[max-depth]';
  }
  const x = n as Record<string, unknown>;
  const out: Record<string, unknown> = {};
  const pick = ['label', 'title', 'classs', 'class', 'routerLink', 'path', 'url', 'menuId', 'id', 'key', 'isExternalLink'];
  for (const k of pick) {
    if (x[k] !== undefined) {
      out[k] = x[k];
    }
  }
  for (const ck of ['children', 'items', 'submenus'] as const) {
    const arr = x[ck];
    if (Array.isArray(arr)) {
      out[`${ck}Count`] = arr.length;
      if (arr[0]) {
        out[`${ck}[0]`] = summarizeMenuNode(arr[0], depth + 1);
      }
    }
  }
  return out;
}

/** So sánh nhanh với logic web-hrm: đếm con theo từng field */
export function countChildrenByField(n: unknown): Record<string, number> {
  if (n == null || typeof n !== 'object') {
    return {};
  }
  const x = n as Record<string, unknown>;
  const counts: Record<string, number> = {};
  for (const k of ['children', 'items', 'submenus'] as const) {
    const arr = x[k];
    counts[k] = Array.isArray(arr) ? arr.length : 0;
  }
  return counts;
}
